/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Forward",
  size: 20
}

const SvgForward = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M2.47 13.11c1.55-3.09 3.8-5.26 6.57-6.5.44-.2 1.23-.48 1.96-.7V2l7.89 7L11 16v-3.87c-1.75.34-3.42 1.06-4.98 2.12-2.99 2.03-4.39 4.29-4.39 4.29s-.25-3.26.84-5.43zm2.83.42c1.62-1.13 3.74-2.13 6.7-2.61v2.71L17.36 9 12 4.25V6.8c-.29.06-1.14.22-2.33.69-2.88 1.16-5.09 3.47-6.18 5.59-.31.62-.81 1.79-1 2.92.79-.95 1.91-1.85 2.81-2.47z" />
  </Svg>
)

SvgForward.defaultProps = defaultProps
export default SvgForward
